import { NavegacionProductos } from '../../components';

const FrijolesRefritosPeruanos = () => {
    return <NavegacionProductos />;
};

export default FrijolesRefritosPeruanos;
